/**
 * MARCADORES DE POSICIÓN — reemplazar por testimonios reales antes de publicar.
 * Si no hay testimonios reales, ocultá la sección con la prop `showTestimonials`.
 */
export const testimonials = [
  {
    quote: '[TESTIMONIO REAL 1 — reemplazar antes de publicar]',
    initials: '01',
    name: '[Nombre y apellido]',
    role: '[Rol / especialidad]',
    location: '[Ciudad, provincia]',
  },
  {
    quote: '[TESTIMONIO REAL 2 — reemplazar antes de publicar]',
    initials: '02',
    name: '[Nombre y apellido]',
    role: '[Rol / especialidad]',
    location: '[Ciudad, provincia]',
  },
  {
    quote: '[TESTIMONIO REAL 3 — reemplazar antes de publicar]',
    initials: '03',
    name: '[Nombre y apellido]',
    role: '[Rol / especialidad]',
    location: '[Ciudad, provincia]',
  },
  {
    quote: '[TESTIMONIO REAL 4 — reemplazar antes de publicar]',
    initials: '04',
    name: '[Nombre y apellido]',
    role: '[Rol / especialidad]',
    location: '[Ciudad, provincia]',
  },
  {
    quote: '[TESTIMONIO REAL 5 — reemplazar antes de publicar]',
    initials: '05',
    name: '[Nombre y apellido]',
    role: '[Rol / especialidad]',
    location: '[Ciudad, provincia]',
  },
  {
    quote: '[TESTIMONIO REAL 6 — reemplazar antes de publicar]',
    initials: '06',
    name: '[Nombre y apellido]',
    role: '[Rol / especialidad]',
    location: '[Ciudad, provincia]',
  },
]
